import { render, staticRenderFns } from "./CarouselFooter.vue?vue&type=template&id=4324fdce&"
import script from "./CarouselFooter.vue?vue&type=script&lang=js&"
export * from "./CarouselFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports